import isEmpty from "utils/value-types/is-empty";

export default function isRowNotEmpty(row, fields) {
  return fields.some(field => !isEmpty(row[field.id], field.type));
}
